import { messages } from "./analyticsConfiguration.messages";
import { FormConfiguration } from "../shared/crud/form";
import { AnalyticsConfiguration } from "./AnalyticsConfiguration";

export function buildSchema() {
  return {
    $schema: "http://json-schema.org/draft-07/schema#",
    required: [],
    type: "object",
    properties: {
      gtmCodes: {
        type: "string",
        pattern: "^GTM-[A-Z0-9]+(,\\s*GTM-[A-Z0-9]+)*$",
      },
    },
    dependencies: {},
  };
}

export function buildFormConfiguration(): FormConfiguration<AnalyticsConfiguration> {
  return {
    __fieldOrder: ["*"],
    __useProtoStyleArrays: true,
    gtmCodes: {
      placeholder: messages.gtmCodesPlaceholder,
      messages: {
        label: messages.gtmCodesLabel,
        helpText: messages.gtmCodesHelpText,
      },
    },
  };
}
